import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ModeProvider } from "./context/ModeContext";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import Scanner from "./pages/Scanner";
import Assistant from "./pages/Assistant";
import Troubleshooter from "./pages/Troubleshooter";
import KnowledgeBase from "./pages/KnowledgeBase";
import AuthCallback from "./pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Read hash from useLocation (reactive), not window.location.hash
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="pt-20">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/scanner" element={<Scanner />} />
          <Route path="/assistant" element={<Assistant />} />
          <Route path="/troubleshooter" element={<Troubleshooter />} />
          <Route path="/knowledge-base" element={<KnowledgeBase />} />
        </Routes>
      </main>
      <footer className="border-t border-border/60 mt-24 py-10">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
          <p className="font-mono text-xs uppercase tracking-[0.2em]">OmniFix AI · Diagnostic Hub</p>
          <p>Simulated diagnostics for demonstration. AI guidance powered by GPT-5.4.</p>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ModeProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" richColors />
        </BrowserRouter>
      </ModeProvider>
    </AuthProvider>
  );
}

export default App;
